(function () {
  var KEY = 'bt_favorites';
  var HEART =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" focusable="false" aria-hidden="true"><path d="M12 21s-6.5-4.35-9.33-7.18A5.5 5.5 0 0 1 12 5.27a5.5 5.5 0 0 1 9.33 8.55C18.5 16.65 12 21 12 21z"/></svg>';
  var syncing = false;
  var rendering = false;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(Boolean).map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function sameList(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  function write(list, opts) {
    var prev = read();
    if (sameList(prev, list)) return;
    localStorage.setItem(KEY, JSON.stringify(list));
    if (opts && opts.silent) return;
    document.dispatchEvent(new CustomEvent('bt:favorites-changed', { detail: { handles: list } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) return false;
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function money(cents, currency) {
    try {
      return (Number(cents) / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      });
    } catch (e) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }

  function setAttrIfChanged(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function syncButtons() {
    if (syncing) return;
    syncing = true;
    try {
      var list = read();
      document.querySelectorAll('[data-bt-fav-handle]').forEach(function (el) {
        var on = list.indexOf(el.getAttribute('data-bt-fav-handle')) !== -1;
        var wantSaved = on;
        if (el.classList.contains('is-saved') !== wantSaved) {
          el.classList.toggle('is-saved', on);
        }
        setAttrIfChanged(el, 'aria-pressed', on ? 'true' : 'false');
        setAttrIfChanged(el, 'aria-label', on ? 'Remove from Favorites' : 'Add to Favorites');
      });
      var n = list.length;
      document.querySelectorAll('[data-bt-fav-count]').forEach(function (el) {
        if (n === 0) {
          if (!el.hasAttribute('hidden')) el.setAttribute('hidden', '');
          el.hidden = true;
          if (el.textContent !== '') el.textContent = '';
          setAttrIfChanged(el, 'aria-hidden', 'true');
        } else {
          if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
          el.hidden = false;
          var s = String(n);
          if (el.textContent !== s) el.textContent = s;
          setAttrIfChanged(el, 'aria-hidden', 'true');
        }
      });
      document.querySelectorAll('[data-bt-fav-drawer-label]').forEach(function (el) {
        var text = n > 0 ? 'Favorites (' + n + ')' : 'Favorites';
        if (el.textContent !== text) el.textContent = text;
      });
      var header = document.querySelector('.bt-fav');
      if (header) {
        setAttrIfChanged(header, 'aria-label', n ? 'Favorites, ' + n + ' saved' : 'Favorites');
      }
    } finally {
      syncing = false;
    }
  }

  function guardFavGesture(e) {
    var btn = e.target.closest('[data-bt-fav-handle]');
    if (!btn) return null;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    return btn;
  }

  function onClick(e) {
    var btn = guardFavGesture(e);
    if (!btn) return;
    if (btn.getAttribute('data-bt-fav-armed') === '1') {
      btn.removeAttribute('data-bt-fav-armed');
      return;
    }
    toggle(btn.getAttribute('data-bt-fav-handle'));
    syncButtons();
  }

  function cardHtml(p) {
    var img =
      (p.featured_image && (p.featured_image.src || p.featured_image)) ||
      (p.images && p.images[0]) ||
      '';
    if (img && typeof img === 'object') img = img.src || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var price = p.price != null ? money(p.price, p.currency || undefined) : '';
    var url = p.url || '/products/' + p.handle;
    return (
      '<article class="bt-fav-card">' +
      '<button type="button" class="bt-card-heart bt-fav-toggle is-saved" data-bt-fav-handle="' +
      p.handle +
      '" aria-pressed="true" aria-label="Remove from Favorites">' +
      HEART +
      '</button>' +
      '<a class="bt-fav-card__media" href="' +
      url +
      '">' +
      (img
        ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400">'
        : '') +
      '</a>' +
      '<a class="bt-fav-card__title" href="' +
      url +
      '">' +
      (p.title || p.handle) +
      '</a>' +
      (price ? '<p class="bt-fav-card__price">' + price + '</p>' : '') +
      '</article>'
    );
  }

  function renderPage() {
    var root = document.querySelector('[data-bt-favorites-page]');
    if (!root || rendering) return;
    rendering = true;
    var grid = root.querySelector('[data-bt-favorites-grid]');
    var empty = root.querySelector('[data-bt-favorites-empty]');
    var handles = read();
    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = '';
      empty.hidden = false;
      rendering = false;
      return;
    }
    empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '<p class="bt-favorites__loading">Loading…</p>';
    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js')
          .then(function (r) {
            if (!r.ok) throw new Error('missing');
            return r.json();
          })
          .then(function (p) {
            p.handle = p.handle || h;
            return p;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var alive = products.filter(Boolean);
      var dead = handles.filter(function (h) {
        return !alive.some(function (p) {
          return p.handle === h;
        });
      });
      if (dead.length) {
        /* silent prune — avoid re-entry via bt:favorites-changed */
        write(
          handles.filter(function (h) {
            return dead.indexOf(h) === -1;
          }),
          { silent: true }
        );
      }
      if (!alive.length) {
        grid.hidden = true;
        grid.innerHTML = '';
        empty.hidden = false;
        syncButtons();
        rendering = false;
        return;
      }
      grid.innerHTML = alive.map(cardHtml).join('');
      syncButtons();
      rendering = false;
    }).catch(function () {
      rendering = false;
    });
  }

  function onPointer(e) {
    var btn = guardFavGesture(e);
    if (!btn) return;
    if (e.type === 'touchstart' && typeof window.PointerEvent === 'function') return;
    if (btn.getAttribute('data-bt-fav-armed') === '1') return;
    btn.setAttribute('data-bt-fav-armed', '1');
    toggle(btn.getAttribute('data-bt-fav-handle'));
    syncButtons();
    setTimeout(function () {
      btn.removeAttribute('data-bt-fav-armed');
    }, 500);
  }

  var changeTimer = null;
  document.addEventListener('click', onClick, true);
  document.addEventListener('pointerdown', onPointer, { capture: true, passive: false });
  document.addEventListener('touchstart', onPointer, { capture: true, passive: false });
  document.addEventListener('bt:favorites-changed', function () {
    if (changeTimer) clearTimeout(changeTimer);
    changeTimer = setTimeout(function () {
      syncButtons();
      renderPage();
    }, 0);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncButtons();
      renderPage();
    });
  } else {
    syncButtons();
    renderPage();
  }
})();
